import { useTranslation } from "react-i18next"
import { CanSendHisAbsenceRequest } from "app/PermissionChecker"
import HomeWidgetLayout from "components/layout/HomeWidgetLayout"
import NewAbsenceRequestModal from "../components/NewAbsenceRequestModal"

function SendAbsenceRequestWidget() {

    const [t, i18n] = useTranslation(["absenceReport"])

    return <HomeWidgetLayout
        title={t("absenceReport:module.short_name")}
        permission={CanSendHisAbsenceRequest}
        content={<>
            <p className="text-muted"><i className="fa-solid fa-file-import fa-2xl"></i></p>
            <p>{t("absenceReport:helper.send_new_request")}</p>
            <NewAbsenceRequestModal />
        </>}
    />
}

export default SendAbsenceRequestWidget